/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductCategoryEnum } from './ProductCategoryEnum';
import {
    ProductCategoryEnumFromJSON,
    ProductCategoryEnumFromJSONTyped,
    ProductCategoryEnumToJSON,
    ProductCategoryEnumToJSONTyped,
} from './ProductCategoryEnum';
import type { ProductFamilyEnum } from './ProductFamilyEnum';
import {
    ProductFamilyEnumFromJSON,
    ProductFamilyEnumFromJSONTyped,
    ProductFamilyEnumToJSON,
    ProductFamilyEnumToJSONTyped,
} from './ProductFamilyEnum';
import type { ProductNatureEnum } from './ProductNatureEnum';
import {
    ProductNatureEnumFromJSON,
    ProductNatureEnumFromJSONTyped,
    ProductNatureEnumToJSON,
    ProductNatureEnumToJSONTyped,
} from './ProductNatureEnum';

/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    itemOrder: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    unit: string;
    /**
     * 
     * @type {ProductFamilyEnum}
     * @memberof Product
     */
    productFamily: ProductFamilyEnum;
    /**
     * 
     * @type {ProductCategoryEnum}
     * @memberof Product
     */
    category: ProductCategoryEnum;
    /**
     * 
     * @type {ProductNatureEnum}
     * @memberof Product
     */
    nature: ProductNatureEnum;
}



/**
 * Check if a given object implements the Product interface.
 */
export function instanceOfProduct(value: object): value is Product {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('itemOrder' in value) || value['itemOrder'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('productFamily' in value) || value['productFamily'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('nature' in value) || value['nature'] === undefined) return false;
    return true;
}

export function ProductFromJSON(json: any): Product {
    return ProductFromJSONTyped(json, false);
}

export function ProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): Product {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'itemOrder': json['itemOrder'],
        'name': json['name'],
        'description': json['description'],
        'unit': json['unit'],
        'productFamily': ProductFamilyEnumFromJSON(json['productFamily']),
        'category': ProductCategoryEnumFromJSON(json['category']),
        'nature': ProductNatureEnumFromJSON(json['nature']),
    };
}

export function ProductToJSON(json: any): Product {
    return ProductToJSONTyped(json, false);
}

export function ProductToJSONTyped(value?: Product | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'itemOrder': value['itemOrder'],
        'name': value['name'],
        'description': value['description'],
        'unit': value['unit'],
        'productFamily': ProductFamilyEnumToJSON(value['productFamily']),
        'category': ProductCategoryEnumToJSON(value['category']),
        'nature': ProductNatureEnumToJSON(value['nature']),
    };
}

